'use strict';

//platformApi  = require('./api'),

var maxAppsCounter = -1,
    iframeFactory = require('../tools/iframe.factory'),
    eventForwarder = require('./event.forwarder'),
    config = require('../tools/config'),

    splash = require('../../components/splash'),

    system = require('./system'),

    Core = require('../kernel/core'),

    $sandboxFrame = null,
    coreManager = null,
    intentManager = null,
    lockedState = null,
    currentTaskIndex = 0,

    checkApp = function ( params, runFromLauncher, meta ) {
        var size = config.data.apps.length,
            index = 0;

        if ( DEVELOP ) {
            debug('iframe')('checkApp: ' + params.config.url);
        }

        while ( index < size ) {
            if ( config.data.apps[index].packageName === params.config.packageName ) {
                if ( config.data.apps[index].locked && window.core.accessControl && !params.omitLock ) {
                    if ( params.ignoreAccessControl ) {
                        params.ignoreAccessControl = false;
                        taskManager.runHistory.forEach(function ( item ) {
                            if ( item.packageName === params.config.packageName ) {
                                params.ignoreAccessControl = true;
                            }
                        });

                        if ( params.ignoreAccessControl ) {
                            return true;
                        }
                    }
                    /* eslint no-loop-func: 0 */
                    lockedState = true;
                    setTimeout(function () {
                        window.core.accessControl.request(function ( error ) {
                            if ( DEVELOP ) {
                                debug('iframe')('access control request error: ' + error);
                            }
                            if ( !error ) {
                                config.data.apps[index].locked = false;
                                taskManager.runApp(params, runFromLauncher);
                                config.data.apps[index].locked = true;
                            }
                            lockedState = false;
                        });
                    }, 0);

                    return true;
                }

                params.config = config.data.apps[index];
                if ( typeof config.data.apps[index].pid !== 'undefined' ) {
                    if ( taskManager.apps[params.config.pid] ) {
                        meta.showSplash = false;
                    } else {
                        params.config.pid = undefined;
                    }
                }

                if ( maxAppsCounter > 0 && taskManager.runHistory.length >= maxAppsCounter ) {
                    taskManager.close(taskManager.apps[taskManager.runHistory[taskManager.runHistory.length - 1].pid]);
                }

                if ( DEVELOP ) {
                    debug('iframe')(params.config.name + ' - ' + params.config.pid);
                }
                break;
            }
            ++index;
        }

        if ( runFromLauncher && system.events['run:app'] ) {
            taskManager.launcher.$iframe.hide();
            taskManager.launcher.core.emit('hide');
            taskManager.launcher.core.emit('blur');
            taskManager.applicationToShow = params;
            system.emit('run:app', {
                done: function () {
                    if ( taskManager.applicationToShow ) {
                        params.omitLock = true;
                        taskManager.runApp(params);
                    }
                    if ( DEVELOP ) {
                        debug('taskmanager')('run app');
                    }
                },
                app: config.data.apps[index]
            });

            return true;
        }

        if ( meta.showSplash ) {
            if ( taskManager.launcher ) {
                taskManager.launcher.$iframe.hide();
                taskManager.launcher.core.emit('hide');
                taskManager.launcher.core.emit('blur');
            }
            splash.show(config.data.apps[index]);
            if ( taskManager.topApp ) {
                taskManager.topApp.$iframe.hide();
                taskManager.topApp.core.emit('hide', {
                    source: window.core.SOURCES.SYSTEM
                });
            }
        } else {
            taskManager.runHistory = taskManager.runHistory.filter(function ( item ) {
                return item.packageName !== params.config.packageName;
            });

            taskManager.runHistory.push(params.config);
            taskManager.show(taskManager.apps[params.config.pid]);

            if ( params.onload ) {
                params.onload(taskManager.apps[params.config.pid]);
            }
            if ( params.onready ) {
                params.onready(taskManager.apps[params.config.pid]);
            }

            return true;
        }

        return false;
    },

    blurOsd = function ( taskInstance ) {
        var task;

        if ( taskManager.osdStack.length > 0 && !taskManager.launcher.$iframe.isVisible ) {
            task = taskManager.osdStack[taskManager.osdStack.length - 1];

            if ( task !== taskInstance && task.$iframe.style.height === screenHeightPx ) {
                // restore focus if the previous OSD was in fullscreen mode
                task.$iframe.contentWindow.focus();
                taskManager.focusedApp = task;
                taskInstance.core.applicationState.focused = true;
                taskManager.focusedApp.core.emit('focus');
                DEVELOP && debug('iframe')('set focused: ' + taskManager.focusedApp.$iframe.src);

                return;
            }

            // taskManager.osdStack.pop();
        }

        if ( taskManager.topApp ) {
            taskManager.osdStack = [];
            taskManager.topApp.$iframe.contentWindow.focus();
            taskManager.focusedApp = taskManager.topApp;
            taskManager.topApp.core.emit('focus');
            DEVELOP && debug('iframe')('set focused: ' + taskManager.topApp.$iframe.src);
        } else if ( taskManager.launcher ) {
            taskManager.osdStack = [];
            taskManager.launcher.$iframe.contentWindow.focus();
            taskManager.focusedApp = taskManager.launcher;
            taskManager.launcher.core.emit('focus');
            DEVELOP && debug('iframe')('set focused: ' + taskManager.launcher.$iframe.src);
        }
    },

    coreCall = {
        app: function ( action ) {
            var taskInstance = taskManager.apps[this.pid],
                params = taskInstance.params,
                activeFocusedOsd, index;

            DEVELOP && debug('iframe')('app core.call ' + action);

            if ( taskManager.focusedApp ) {
                activeFocusedOsd = taskManager.focusedApp.config.type === 'osd' ? taskManager.focusedApp : null;
            }

            switch ( action ) {
                case 'exit':
                    // remove app from history and close it
                    taskManager.close(taskInstance);
                    index = taskManager.runHistory.indexOf(taskInstance.config);
                    if ( index !== -1 ) {
                        taskManager.runHistory.splice(index, 1);
                    }
                    break;

                case 'stop':
                    // only close
                    taskManager.close(taskInstance);
                    break;

                case 'app:ready':
                    if ( params.visible && splash.active ) {
                        splash.hide();

                        taskManager.show(taskInstance);

                        if ( activeFocusedOsd ) {
                            activeFocusedOsd.$iframe.contentWindow.focus();
                        }
                    }

                    taskInstance.core.emit('app:ready');

                    taskManager.runHistory = taskManager.runHistory.filter(function ( item ) {
                        if ( item.url === params.config.url ) {
                            return false;
                        }

                        return true;
                    });

                    DEVELOP && debug('system')('add app ' + params.config.packageName + ' to run history');

                    if ( taskManager.home ) {
                        if ( params.config.home ) {
                            taskManager.runHistory.push(taskManager.home.config);
                        } else {
                            taskManager.runHistory.push(params.config);
                        }
                    } else {
                        taskManager.runHistory.push(params.config);
                    }

                    if ( params.onready ) {
                        params.onready();
                    }
                    break;

                case 'hide':
                    taskManager.hideAll();
                    break;
            }
        },
        osd: function ( action ) {
            var taskInstance = taskManager.apps[this.pid],
                params = taskInstance.params,
                index;

            switch ( action ) {
                case 'hide':
                    DEVELOP && debug('iframe')('osd call hide ' + params.config.url);
                    DEVELOP && debug('iframe')('osd stack length before check ' + taskManager.osdStack.length);

                    index = taskManager.osdStack.indexOf(taskInstance);

                    if ( index !== -1 ) {
                        taskManager.osdStack.splice(index, 1);
                    }

                    DEVELOP && debug('iframe')('osd stack length after check ' + taskManager.osdStack.length);

                    taskInstance.$iframe.style.zIndex = '';

                    taskManager.osdStack.forEach(function ( task, osdIndex ) {
                        task.$iframe.style.zIndex = osdIndex + frames.length + 1;

                        DEVELOP && debug('iframe')(task.$iframe.style.zIndex);
                    });

                    taskInstance.core.applicationState.visible = false;
                    taskInstance.$iframe.hide();

                    if ( document.activeElement === document.body && taskManager.focusedApp !== taskManager.topApp ) {
                        if ( taskManager.topApp ) {
                            taskManager.focusedApp = taskManager.topApp;

                            DEVELOP && debug('iframe')('set focused app as ' + taskManager.focusedApp.$iframe.src);

                            taskManager.focusedApp.$iframe.contentWindow.focus();
                        }
                    }
                    break;

                case 'app:ready':
                    DEVELOP && debug('iframe')('osd call app:ready ' + params.config.url);

                    if ( params.onready ) {
                        params.onready();
                    }
                    break;

                case 'show':
                    DEVELOP && debug('iframe')('osd call show ' + params.config.url);

                    if ( splash.active ) {
                        // splash.hide();
                        window.splash.style.zIndex = window.frames.length;
                        // console.log(window.splash.style.zIndex)
                    }

                    index = taskManager.osdStack.indexOf(taskInstance);

                    if ( index === -1 ) {
                        taskManager.osdStack.push(taskInstance);
                    } else {
                        taskManager.osdStack.splice(index, 1);
                        taskManager.osdStack.push(taskInstance);
                    }
                    taskManager.osdStack.forEach(function ( task, osdIndex ) {
                        task.$iframe.style.zIndex = osdIndex + window.frames.length + 1;

                        DEVELOP && debug('iframe')(task.$iframe.style.zIndex);
                    });

                    taskInstance.core.applicationState.visible = true;
                    taskInstance.$iframe.show();

                    if ( params.config.type === 'auth' ) {
                        if ( !taskManager.launcher ) {
                            taskManager.launcher = taskInstance;
                            if ( DEVELOP ) {
                                debug('iframe')('set auth as launcher');
                            }
                        }
                    }
                    break;

                case 'focus':
                    DEVELOP && debug('iframe')('osd call focus ' + params.config.url);

                    if ( taskManager.topApp ) {
                        taskManager.topApp.core.emit('blur');
                    } else if ( taskManager.launcher ) {
                        taskManager.launcher.core.emit('blur');
                    }

                    taskInstance.core.applicationState.focused = true;
                    taskInstance.$iframe.contentWindow.focus();
                    taskManager.focusedApp = taskInstance;
                    DEVELOP && debug('iframe')('set focused app as ' + taskManager.focusedApp.$iframe.src);
                    break;

                case 'blur':
                    DEVELOP && debug('iframe')('osd call blur ' + params.config.url);
                    DEVELOP && debug('iframe')('osd stack length ' + taskManager.osdStack.length);
                    blurOsd(taskInstance);
                    break;
            }
        },
        system: function ( action ) {
            var taskInstance, params;

            if ( this.pid === -1 ) {
                // launcher
                taskInstance = taskManager.launcher;
            } else {
                taskInstance = taskManager.apps[this.pid];
            }

            params = taskInstance.params;

            switch ( action ) {
                case 'exit':
                    taskManager.close(taskInstance);
                    // taskManager.stack.forEach(function ( task ) {
                    //     task.core.emit('close');
                    // });
                    if ( params.config.type === 'launcher' ) {
                        require('./api').exit();
                    }
                    break;

                case 'hide':
                    taskManager.hide(taskInstance, {source: Core.prototype.SOURCES.SYSTEM});
                    break;

                case 'show':
                    taskManager.show(taskInstance, {source: Core.prototype.SOURCES.SYSTEM});
                    break;

                case 'app:ready':
                    // this.appReady = true;
                    this.emit('app:ready');
                    if ( DEVELOP ) {
                        taskInstance.$iframe.contentWindow.onunload = function () {
                            coreManager.destroy(taskInstance.$iframe.contentWindow);
                        };
                    }

                    if ( params.onready ) {
                        params.onready();
                    }

                    break;
            }
        }
    },

    dispatchEventToActiveApp = function ( event ) {
        var appTarget = taskManager.topApp || taskManager.launcher,
            index = 0,
            customEvent, keys, keysSize, target;

        customEvent = document.createEvent('Event');

        customEvent.initEvent(event.name, !!event.bubbles, !!event.cancelable);
        keys = Object.keys(event);
        keys = keys.filter(function ( name ) {
            return (name !== 'bubbles' && name !== 'cancelable');
        });
        keysSize = keys.length;
        while ( index < keysSize ) {
            customEvent[keys[index]] = event[keys[index]];
            ++index;
        }
        if ( event.name === 'click' ) {
            if ( DEVELOP ) {
                debug('iframe')(event.clientY + '.' + event.clientX);
            }
            target = appTarget.$iframe.contentDocument.elementFromPoint(event.clientX, event.clientY);
            if ( !target ) {
                return;
            }
        } else {
            target = appTarget.$iframe.contentWindow;
        }
        target.dispatchEvent(customEvent);
    },

    redirectTo = function ( url ) {
        location.href = url;
    },

    fullfillCoreObject = function ( core, params ) {
        // first load
        core.storage = new core.constructor.prototype.Storage(params.config.packageName || params.config.name);

        Object.defineProperty(core, 'state', {
            get: function () {
                return core.storage.getItem('state');
            },
            set: function ( value ) {
                core.storage.setItem('state', value);
            }
        });

        switch ( params.config.type ) {
            case 'app':
                core.call = coreCall.app;
                break;

            case 'osd':
            case 'auth':
                core.system = true;
                core.config = config.data;
                core.redirectTo = redirectTo;

                core.call = coreCall.osd;
                core.dispatchEventToActiveApp = dispatchEventToActiveApp;
                break;

            default:
                core.system = true;
                core.config = config.data;
                core.redirectTo = redirectTo;
                core.call = coreCall.system;
                break;

        }
    },

    taskManager = {
        topApp: null,
        stack: [],
        daemons: [],
        runHistory: [],
        apps: {},
        launcher: null,
        launchers: [],
        home: null,
        homeConfig: null,
        focusedApp: null,
        applicationToShow: false,
        onDoneCallback: null,
        osdStack: [],
        show: function ( task, meta ) {
            var type = task.config.type,
                index;

            meta = meta || {source: Core.prototype.SOURCES.LAUNCHER};

            // window.top.console.log('this.topApp === task ' + this.topApp === task);
            if ( this.topApp === task ) {
                return;
            }

            DEVELOP && debug('iframe')('show ' + task.config.type + ':' + task.config.name);
            DEVELOP && debug('iframe')('meta ' + meta.source);

            switch ( type ) {
                case 'osd':
                    if ( splash.active ) {
                        splash.hide();
                    }

                    index = taskManager.osdStack.indexOf(task);
                    if ( index === -1 ) {
                        taskManager.osdStack.push(task);
                    } else {
                        taskManager.osdStack.splice(index, 1);
                        taskManager.osdStack.push(task);
                    }

                    taskManager.osdStack.forEach(function ( osdTask, osdIndex ) {
                        osdTask.$iframe.style.zIndex = osdIndex + window.frames.length + 1;
                        DEVELOP && debug('iframe')(osdTask.$iframe.style.zIndex);
                    });

                    task.$iframe.show();
                    break;

                case 'app':
                    if ( this.launcher ) {
                        this.launcher.$iframe.hide();
                        this.launcher.core.emit('hide');
                        this.launcher.core.emit('blur');
                    }
                    $sandboxFrame.style.zIndex = window.frames.length;

                    /* eslint no-fallthrough: 0 */

                case 'system':
                    if ( type === 'system' ) {
                        $sandboxFrame.style.zIndex = 0;
                        task.$iframe.style.zIndex = window.frames.length;
                    }

                    index = this.stack.indexOf(task);
                    if ( index !== -1 ) {
                        this.stack.splice(index, 1);
                    }

                    this.stack.push(task);

                    DEVELOP && debug('app', this.topApp);

                    if ( this.topApp ) {
                        // window.top.console.log('this.topApp !== task ' + this.topApp === task);
                        if ( this.topApp !== task ) {
                            if ( typeof this.topApp.core.emit === 'function' ) {
                                // app can remove this method for own 'core'
                                // make own core as non-editable
                                this.topApp.core.emit('hide', meta);
                            }

                            if ( this.topApp ) {
                                this.topApp.$iframe.hide();
                            }
                        }
                    }

                    this.topApp = task;

                    DEVELOP && debug('iframe')('focus ' + task.config.type + ':' + task.config.name);

                    task.$iframe.contentWindow.focus();
                    taskManager.focusedApp = task;
                    // window.top.console.log('set focused app as ' + task.$iframe.src);
                    // window.core.pid = task.core.pid;
                    if ( splash.active ) {
                        splash.hide();
                    }
                    task.$iframe.show();
                    // window.top.console.log('task.$iframe.style ' + task.$iframe.style.toString());


                    if ( task.core && typeof task.core.emit === 'function' ) {
                        // app can remove this method for own 'core'
                        // maybe need to make own core as non-editable
                        if ( DEVELOP ) {
                            debug('core')('emit show ' + JSON.stringify(meta.config));
                            debug('core')('emit show ' + JSON.stringify(meta.source));
                        }
                        task.core.emit('show', meta);
                        task.core.emit('focus', meta);
                    }
                    break;

                case 'launcher':
                    if ( type === 'launcher' ) {
                        taskManager.topApp = null;
                        window.core.pid = task.core.pid;
                    }

                    taskManager.osdStack.forEach(function ( osdTask ) {
                        if ( osdTask.config.type === 'auth' ) {
                            osdTask.$iframe.style.zIndex = 0;
                        }
                    });

                default:
                    task.$iframe.contentWindow.focus();
                    task.core.emit('focus', meta);
                    task.core.emit('show', meta);
                    taskManager.focusedApp = task;
                    // window.core.pid = task.core.pid;
                    task.$iframe.show();

                    break;
            }
        },
        hide: function ( task, meta ) {
            var type = task.config.type;

            meta = meta || {source: Core.prototype.SOURCES.LAUNCHER};

            task.$iframe.hide();

            if ( task.core && typeof task.core.emit === 'function' ) {
                // app can remove this method for own 'core'
                // maybe need to make own core as non-editable
                task.core.emit('hide', meta);
            }
            if ( DEVELOP ) {
                debug('iframe')('hide ' + task.config.type + ':' + task.config.name);
                debug('iframe')('meta ' + meta.source);
            }

            switch ( type ) {
                case 'app':
                case 'system':
                    if ( this.topApp === task ) {
                        this.topApp = null;
                    }
                    this.stack.pop();
                    if ( this.stack.length > 0 ) {
                        this.show(this.stack.pop(), meta);
                    } else {
                        this.show(this.launcher, meta);
                    }
                    break;
            }
        },
        close: function ( task, forceLauncher ) {
            var size = config.data.apps.length,
                index = 0,
                keys, stackIndex;

            if ( typeof task === 'undefined' ) {
                if ( !forceLauncher ) {
                    this.show(this.launcher);
                }
            } else if ( task.config.type === 'app' ) {
                // not a system module
                if ( task === this.topApp ) {
                    this.topApp = null;
                    this.stack.pop();
                } else {
                    stackIndex = this.stack.indexOf(task);
                    this.stack.splice(stackIndex, 1);
                }

                // if ( task === this.home ) {
                // task.$iframe.hide();
                // while ( this.stack.length ) {
                //     task = this.stack.pop();
                //     task.$iframe.hide();
                //     task.core.emit('hide', {
                //         source: Core.prototype.SOURCES.LAUNCHER
                //     });
                // }
                // this.topApp = null;
                // $sandboxFrame.style.zIndex = 0;
                // task.core.emit('hide', {
                //     source: Core.prototype.SOURCES.LAUNCHER
                // });
                // this.show(this.launcher);

                // return;
                // }

                task.core.emit('exit');
                if ( intentManager.lastRoute && intentManager.lastRoute.core === task.core ) {
                    // hide opened app
                    taskManager.hide(taskManager.apps[intentManager.lastRoute.intent.receiver]);
                }

                // clear pid
                while ( index < size ) {
                    if ( config.data.apps[index].packageName === task.config.packageName ) {
                        config.data.apps[index] = JSON.parse(JSON.stringify(config.data.apps[index]));
                        config.data.apps[index].pid = undefined;
                        intentManager.replaceActionsConfig(task.config, config.data.apps[index]);
                        break;
                    }
                    ++index;
                }

                coreManager.destroy(task.window);

                $sandboxFrame.contentDocument.body.removeChild(task.$iframe);

                keys = Object.keys(taskManager.apps);
                size = keys.length;
                index = 0;

                while ( index < size ) {
                    if ( taskManager.apps[keys[index]] === task ) {
                        taskManager.apps[keys[index]] = null;
                        if ( DEVELOP ) {
                            debug('iframe')('remove  ' + index);
                        }
                        break;
                    }
                    ++index;
                }

                if ( DEVELOP ) {
                    debug('iframe')('close: ' + task.config.url);
                }
                task.config.pid = undefined;
                task = null;

                if ( !forceLauncher ) {
                    this.reset(task);
                }
            } else {
                // system app close
                this.reset(task);
            }
        },

        reset: function ( task ) {
            // system app close
            while ( this.stack.length ) {
                task = this.stack.pop();
                task.$iframe.hide();
                task.core.emit('hide', {source: Core.prototype.SOURCES.LAUNCHER});
            }
            this.topApp = null;
            $sandboxFrame.style.zIndex = 0;
            this.show(this.launcher);
        },

        /**
         * Run application in irame.
         *
         * @param {Object} params application parameters
         * @param {boolean} runFromLauncher indicates that called from launcher
         */
        /* eslint max-lines-per-function: ['error', {max: 160, skipBlankLines: true, skipComments: true}] */
        runApp: function ( params, runFromLauncher ) {
            var metrics      = {},
                taskIndex    = -1,
                taskInstance = null,
                meta = {
                    showSplash: true
                },
                referrer;

            if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
                if ( params.config.native ) {
                    return require('../platforms/mag/utils').runNativeApp(params.config);
                }
            }

            if ( params.config.legacy ) {
                // for legacy apps
                if ( MODE === 'MINISTRA' ) {
                    referrer = 'referrer=' + encodeURIComponent(config.data.options.stalkerHost + config.data.options.stalkerLoaderPath);

                    if ( params.config.url.indexOf('?') === -1 ) {
                        DEVELOP && debug('iframe')('RUN LEGACY APP ' + params.config.url + '?' + referrer);
                        location.href = params.config.url + '?' + referrer;
                    } else {
                        location.href = params.config.url + '&' + referrer;
                        DEVELOP && debug('iframe')('RUN LEGACY APP ' + params.config.url + '&' + referrer);
                    }
                } else {
                    referrer = 'referrer=' + encodeURIComponent(location.href);

                    if ( params.config.url.indexOf('?') === -1 ) {
                        DEVELOP && debug('iframe')('RUN LEGACY APP ' + params.config.url + '?' + referrer);
                        location.href = params.config.url + '?' + referrer;
                    } else {
                        DEVELOP && debug('iframe')('RUN LEGACY APP ' + params.config.url + '&' + referrer);
                        location.href = params.config.url + '&' + referrer;
                    }
                }

                return null;
            }

            if ( params.config.type === 'app' ) {
                if ( checkApp(params, runFromLauncher, meta ) ) {
                    return null;
                }
            } else if ( params.config.metrics && params.config.metrics[screenHeight] ) {
                metrics = params.config.metrics[screenHeight];
                // metrics.height = params.config.metrics[screenHeight].height;
                // metrics.top = params.config.metrics[screenHeight].top;
                // metrics.left = params.config.metrics[screenHeight].left;
            }

            function prepareApp () {
                var core;

                DEVELOP && debug('iframe')('PREPARE APP ' + params.config.name);

                if ( taskInstance && taskInstance.window ) {
                    core = require('../kernel/core.manager').getInstance(taskInstance.window);
                    taskInstance.core = core;

                    if ( !taskInstance.window.pid ) {
                        taskInstance.window.pid = taskIndex;
                    }

                    if ( typeof core.call === 'undefined' ) {
                        // first load
                        fullfillCoreObject(core, params);
                    }

                    core.pid = taskIndex;

                    core.resolveDependencies(params.config, function () {
                        core.ready = true;
                        if ( params.config.home ) {
                            core.applicationState.home = true;
                        }

                        core.emit('load');

                        if ( params.onload ) {
                            params.onload(taskInstance);
                        }
                    });
                }
            }

            DEVELOP && debug('iframe')('runApp: ' + params.config.url);

            taskInstance = {
                $iframe: iframeFactory({
                    url: params.config.url,
                    type: params.config.type,
                    visible: false,
                    $container: params.config.type === 'app' ? $sandboxFrame.contentDocument.body : window.document.body,
                    width: metrics.width,
                    height: metrics.height,
                    top: metrics.top,
                    left: metrics.left,
                    onload: function () {
                        if ( DEVELOP ) {
                            debug('iframe')('iframe ' + params.config.name + ' load');
                        }

                        this.contentWindow.addEventListener('keydown', function ( event ) {
                            var eventName;

                            if ( event.keyCode === 0 ) {
                                return;
                            }

                            if ( event.keyCode === 9 ) {
                                event.preventDefault();
                            }

                            eventName = 'keydown:' + require('spa-keyboard-event-parser')(event);

                            if ( DEVELOP ) {
                                debug('iframe')(params.config.name + ' event ' + eventName);
                            }
                            eventForwarder(eventName, event);
                        });

                        taskInstance.window = this.contentWindow;
                        prepareApp();
                    },
                    onerror: function ( error ) {
                        if ( DEVELOP ) {
                            debug('iframe')('iframe ' + params.config.name + ' not load, error: ' + error);
                        }
                        taskManager.close(taskInstance);
                        setTimeout(function () {
                            if ( params.visible && splash.active ) {
                                splash.hide();
                            }
                        }, 5000);
                        if ( params.onerror ) {
                            params.onerror(error);
                        }
                    }
                }),
                window: null,
                core: null,
                config: params.config,
                params: params
            };

            if ( taskManager.home && params.config.home ) {
                taskManager.home = taskInstance;
            }

            taskInstance.core = require('../kernel/core.manager').getInstance(taskInstance.$iframe.contentWindow);
            // taskInstance.$iframe.contentWindow.onunload = function () {
            //     if ( coreManager === null ) {
            //         coreManager = require('../kernel/core.manager');
            //     }

            //     console.log('on unload ' + this.location.href);
            //     coreManager.destroy(taskInstance.$iframe.contentWindow);
            // };

            // if ( params.config.type === 'app' ) {
            //     taskManager.runHistory = taskManager.runHistory.filter(function ( item ) {
            //         if ( item.url === params.config.url ) {
            //             return false;
            //         }

            //         return true;
            //     });
            //     // console.log('PUSH TO RUN GHISTORY');
            //     if ( taskManager.home ) {
            //         console.log(params.config === taskManager.home.config);
            //         console.log(params.config.url);
            //         console.log(taskManager.home.config.url);
            //     }
            //     if ( taskManager.home ) {
            //         if ( params.config.home ) {
            //             taskManager.runHistory.push(taskManager.home.config);
            //         } else {
            //             taskManager.runHistory.push(params.config);
            //         }
            //     } else {
            //         taskManager.runHistory.push(params.config);
            //     }
            // }
            if ( params.config.type !== 'launcher' ) {
                if ( DEVELOP ) {
                    debug('iframe')('currentTaskIndex ' + currentTaskIndex);
                }
                taskIndex = currentTaskIndex;
                ++currentTaskIndex;
                if ( DEVELOP ) {
                    debug('iframe')('new taskIndex ' + taskIndex);
                }
                taskManager.apps[taskIndex] = taskInstance;
                if ( DEVELOP ) {
                    debug('iframe')('currentTaskIndex ' + currentTaskIndex);
                }
            }

            params.config.pid = taskIndex;

            return taskInstance;
        },
        hideAll: function () {
            var apps = [],
                index, indexes, type, isVisible;


            taskManager.onDoneCallback = null;
            taskManager.applicationToShow = null;

            indexes = Object.keys(taskManager.apps);
            index = indexes.length - 1;

            if ( splash.active ) {
                splash.hide();
            }

            while ( index > -1 ) {
                if ( taskManager.apps[indexes[index]] ) {
                    // not closed
                    type = taskManager.apps[indexes[index]].config.type;
                    isVisible = taskManager.apps[indexes[index]].$iframe.isVisible;
                    if ( taskManager.apps[indexes[index]].core ) {
                        if ( type === 'osd' || type === 'auth' ) {
                            if ( isVisible ) {
                                taskManager.apps[indexes[index]].core.emit('hide', {source: Core.prototype.SOURCES.LAUNCHER});
                            }
                        } else if ( type === 'app' ) {
                            apps.push(taskManager.apps[indexes[index]]);
                            if ( isVisible ) {
                                taskManager.apps[indexes[index]].core.emit('hide', {source: Core.prototype.SOURCES.LAUNCHER});
                            }
                        } else if ( isVisible ) {
                            if ( DEVELOP ) {
                                debug('iframe')('hide ' + taskManager.apps[indexes[index]].config.name);
                            }
                            taskManager.apps[indexes[index]].$iframe.hide();
                            taskManager.apps[indexes[index]].core.emit('hide', {source: Core.prototype.SOURCES.LAUNCHER});
                        }
                    }
                }
                --index;
            }

            index = 0;
            while ( index < apps.length ) {
                isVisible = apps[index].$iframe.isVisible;
                if ( isVisible ) {
                    if ( DEVELOP ) {
                        debug('iframe')('hide ' + taskManager.apps[indexes[index]].config.name);
                    }
                    apps[index].$iframe.hide();
                    apps[index].core.emit('hide', {source: Core.prototype.SOURCES.LAUNCHER});
                }
                ++index;
            }

            $sandboxFrame.style.zIndex = 0;

            taskManager.topApp = null;
            if ( lockedState ) {
                if ( taskManager.launcher.$iframe.isVisible ) {
                    return;
                }
                taskManager.show(taskManager.launcher);
                taskManager.launcher.core.emit('focus');
            } else if ( taskManager.home ) {
                if ( taskManager.home.config.locked ) {
                    if ( !taskManager.launcher.core.applicationState.visibile ) {
                        taskManager.show(taskManager.launcher);
                        taskManager.launcher.core.emit('focus');
                    }

                    return;
                }
                // console.log(taskManager.launcher.$iframe.isVisible);
                // console.log(taskManager.runHistory.indexOf(this.home.config));
                if ( taskManager.launcher.$iframe.isVisible ) {
                    if ( taskManager.runHistory.indexOf(this.home.config) === -1 ) {
                        taskManager.show(taskManager.launcher);
                        taskManager.launcher.core.emit('focus');
                    } else {
                        if ( this.launcher ) {
                            this.launcher.$iframe.hide();
                        }
                        // taskManager.runHistory.push(this.home.config);
                        taskManager.show(taskManager.home);
                    }
                } else {
                    taskManager.show(taskManager.launcher);
                    taskManager.launcher.core.emit('focus');
                }
            } else if ( taskManager.launcher ) {
                if ( !taskManager.launcher.core.applicationState.focused ) {
                    taskManager.launcher.core.emit('focus');
                }

                taskManager.show(taskManager.launcher);
            }
        },
        init: function () {
            coreManager = require('../kernel/core.manager');
            intentManager = require('./intent.manager');
            // return function ( done ) {
            //if ( !QUIET_BOOT ) {
            //    window.logger.push('Loading sandbox');
            //}
            maxAppsCounter = config.data.options.maxAppsCounter || maxAppsCounter;

            if ( DEVELOP ) {
                debug('iframe')('INIT TASK MANAGER');
                debug('MAX APPS COUNTER')(maxAppsCounter);
            }
            // create sandbox iframe for apps
            $sandboxFrame = iframeFactory({
                $container: document.body,
                visible: true,
                onload: function () {
                    var $link = this.contentDocument.head.appendChild(this.contentDocument.createElement('style'));/* ,
                        keys = Object.keys(platformApi),
                        keysSize = keys.length,
                        index = 0; */

                    /* eslint no-use-before-define: 0 */
                    $link.textContent = 'html, body{ background: transparent !important; overflow: hidden; margin: 0; padding:0; width: ' +
                        screenWidth + 'px; height: ' + screenHeight + 'px; } ' +
                        'iframe { position: absolute; top: 0; left: 0; border: none; outline: none; overflow: hidden;margin: 0; padding: 0; width: ' +
                        screenWidth + 'px; height: ' + screenHeight + 'px; }';

                    this.contentWindow.parent = null;
                    this.contentWindow.opener = null;
                    //                        this.contentWindow.frames = null;
                    //                        this.contentWindow.top    = null;
                    this.contentWindow.getCoreInstance = function ( contentWindow ) {
                        return require('../kernel/core.manager').getInstance(contentWindow);
                    };
                    // remove this after legacy apps come to new sdk

                    // remove this hack when 'core' implement all api
                    // while ( index < keysSize ) {
                    //     this.contentWindow[keys[index]] = platformApi[keys[index]];
                    //     ++index;
                    // }

                    // done(false, {config: {}, instance: null, $iframe: $sandboxFrame});
                }
            });
            // };
        },
        lockApp: function ( appConfig, callback ) {
            var cfg      = window.core.storage.getItem('config') || {},
                apps     = cfg.apps || [],
                size     = config.data.apps.length,
                index    = 0,
                appIndex = 0;

            if ( window.core.accessControl ) {
                window.core.accessControl.request(function ( error ) {
                    if ( !error ) {
                        while ( index < size ) {
                            if ( config.data.apps[index].packageName === appConfig.packageName ) {
                                appIndex = index;
                                index = 0;
                                size = apps.length;
                                config.data.apps[appIndex].locked = !config.data.apps[appIndex].locked;

                                while ( index < size ) {
                                    if ( config.data.apps[appIndex].packageName === apps[index].packageName ||
                                        config.data.apps[appIndex].name === apps[index].name ) {
                                        apps[index] = config.data.apps[appIndex];
                                        break;
                                    }
                                    ++index;
                                }

                                if ( index === size ) {
                                    apps.push(config.data.apps[appIndex]);
                                }

                                break;
                            }
                            ++index;
                        }

                        cfg.apps = apps;

                        window.core.storage.setItem('config', cfg);
                    }
                    callback(error);
                });
            } else {
                callback(true);
            }
        },
        setHomeApp: function ( homeAppConfig ) {
            if ( DEVELOP ) {
                debug('iframe')('set home app ' + homeAppConfig.name);
            }

            if ( this.home === null ) {
                // splash.init();
                homeAppConfig.home = true;
                // console.log(JSON.stringify(config));
                // console.log('HOME INSTALLED 1132');
                // if ( this.launcher && this.launcher.$iframe ) {
                //     this.launcher.$iframe.hide();
                //     this.launcher.core.emit('hide');
                //     this.launcher.core.emit('blur');
                // }
                taskManager.homeConfig = homeAppConfig;
                // taskManager.home  = this.runApp({
                //     config: config,
                //     visible: false,
                //     onload: function () {
                //         taskManager.launcher.$iframe.hide();
                //     }
                // });
                // console.log(taskManager.home.$iframe.src);
            }
        },
        killAll: function ( ignoredWindow ) {
            var ids = Object.keys(taskManager.apps);

            ids.forEach(function ( id ) {
                var task = taskManager.apps[id];

                if ( task === null ) {
                    return;
                }

                if ( task.window === ignoredWindow ) {
                    taskManager.launcher = task;
                } else {
                    task.core.emit('exit');

                    coreManager.destroy(task.window);
                    if ( task.config.type === 'app' ) {
                        $sandboxFrame.contentDocument.body.removeChild(task.$iframe);
                    } else {
                        document.body.removeChild(task.$iframe);
                    }
                }
            });

            this.topApp = this.focusedApp = taskManager.launcher;
            // console.log('set focused app as ' + taskManager.launcher.$iframe.src);
            this.home = null;
            taskManager.apps = {};
            this.runHistory.splice(0);
            taskManager.osdStack.splice(0);
            this.stack.splice(0);

            if ( PLATFORM === 'MAG' || NANOCORE ) {
                require('../platforms/mag/storage').forceFlush();
            }
        },
        setLauncher: function ( targetWindow ) {
            taskManager.home = null;
            Object.keys(taskManager.apps).forEach(function ( id ) {
                if ( taskManager.apps[id] && taskManager.apps[id].window === targetWindow ) {
                    taskManager.launcher = taskManager.apps[id];
                }
            });
        }
    },

    screenHeightPx, screenHeight, screenWidth;


if ( DEVELOP ) {
    window.ta = taskManager;
}

screenHeight = screen.height;
switch ( screenHeight ) {
    case 480:
    case 576:
    case 720:
    case 1080:
        break;

    default:
        screenWidth = 1280;
        screenHeight = 720;
        break;
}

screenHeightPx = screenHeight + 'px';

module.exports = taskManager;
